export default __webpack_public_path__ + "static/media/Python.3bd37691.svg";